var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAccount(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 106.688,
    height: 118.768,
    viewBox: "0 0 106.688 118.768",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1206",
    "data-name": "Group 1206",
    transform: "translate(23522.564 -18523.631)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Subtraction_3",
    "data-name": "Subtraction 3",
    transform: "translate(-23502.91 18523.631)",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32.243,62.507a32.92,32.92,0,0,1-12.55-2.456,32.209,32.209,0,0,1-10.249-6.7,31.114,31.114,0,0,1-6.91-9.934,30.473,30.473,0,0,1,0-24.331,31.114,31.114,0,0,1,6.91-9.934,32.209,32.209,0,0,1,10.249-6.7,33.349,33.349,0,0,1,21.9-1.123A33.106,33.106,0,0,0,36.639.962C19.13.962,4.886,14.766,4.886,31.735c0,16.12,12.986,29.605,29.564,30.7C33.708,62.484,32.966,62.507,32.243,62.507Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 17.33012771606445 57.62089920043945 C 9.04987907409668 51.77888107299805 3.685590267181396 42.30184555053711 3.685590267181396 31.73480033874512 C 3.685590267181396 18.61445045471191 11.87185573577881 7.314989566802979 23.5498218536377 2.392493009567261 C 22.39723205566406 2.717828273773193 21.26217842102051 3.109279870986938 20.14739036560059 3.566319704055786 C 16.44991111755371 5.082209587097168 13.12961006164551 7.25201940536499 10.27873039245605 10.01546001434326 C 7.430450439453125 12.77637004852295 5.194700241088867 15.99031925201416 3.633590221405029 19.56803894042969 C 2.01878023147583 23.26885032653809 1.200000166893005 27.200439453125 1.200000166893005 31.25358963012695 C 1.200000166893005 35.30673980712891 2.01878023147583 39.23833084106445 3.633590221405029 42.93914031982422 C 5.194690227508545 46.51686096191406 7.430440425872803 49.73080825805664 10.27873039245605 52.49171829223633 C 12.38521385192871 54.53360366821289 14.74827480316162 56.25153350830078 17.33012771606445 57.62089920043945 M 32.24259948730469 62.50717926025391 C 27.88980102539062 62.50717926025391 23.6672306060791 61.68085861206055 19.69218063354492 60.05117034912109 C 15.85272979736328 58.47706985473633 12.40458011627197 56.22360992431641 9.443520545959473 53.35335922241211 C 6.482429981231689 50.48310852050781 4.157649993896484 47.14072799682617 2.533730268478394 43.41904830932617 C 0.8524702191352844 39.56594848632812 2.166748060972168e-07 35.4728889465332 2.166748060972168e-07 31.25358963012695 C 2.166748060972168e-07 27.03429985046387 0.8524702191352844 22.94122886657715 2.533730268478394 19.0881290435791 C 4.157649993896484 15.36645984649658 6.482429981231689 12.02406978607178 9.443520545959473 9.153820037841797 C 12.40458011627197 6.28357982635498 15.85272979736328 4.030109405517578 19.69218063354492 2.45600962638855 C 23.6672306060791 0.8263196349143982 27.88980102539062 -3.698730495216296e-07 32.24259948730469 -3.698730495216296e-07 C 35.42546844482422 -3.698730495216296e-07 38.56975173950195 0.4485296308994293 41.58810043334961 1.333099603652954 C 39.9669303894043 1.087199687957764 38.30205154418945 0.9615596532821655 36.63927841186523 0.9615596532821655 C 19.13022994995117 0.9615596532821655 4.885590076446533 14.76637935638428 4.885590076446533 31.73480033874512 C 4.885590076446533 47.85511779785156 17.87149047851562 61.34029006958008 34.4492301940918 62.43510055541992 C 33.70829010009766 62.48357009887695 32.96586990356445 62.50717926025391 32.24259948730469 62.50717926025391 Z",
    stroke: "none",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_30",
    "data-name": "Ellipse 30",
    transform: "translate(-23499.027 18524.119)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1.2
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 31.754,
    cy: 31.265,
    rx: 31.754,
    ry: 31.265,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 31.754,
    cy: 31.265,
    rx: 31.154,
    ry: 30.665,
    fill: "none"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Subtraction_4",
    "data-name": "Subtraction 4",
    d: "M.1,53.552v0h0C.034,52.482,0,51.394,0,50.317A50.331,50.331,0,0,1,96.223,29.681,49.929,49.929,0,0,1,100.609,48.7Z",
    transform: "translate(-23517.104 18588.113)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Subtraction_7",
    "data-name": "Subtraction 7",
    d: "M4.972,53.279h0L0,50.789v-.177q0-.147,0-.3A50.276,50.276,0,0,1,50.317,0c.812,0,1.634.019,2.442.058A50.273,50.273,0,0,0,4.886,50.317c0,.988.029,1.984.086,2.96Z",
    transform: "translate(-23521.965 18588.113)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1.2
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccount);
export default __webpack_public_path__ + "static/media/account.52986d978552c914fe4010638bae49e9.svg";
export { ForwardRef as ReactComponent };